import {
  CustomerMassQueryResult,
  ExecuteMassCustomerQuery,
  NewFavoriteQuery,
} from '../types/query';
import { queryService } from '../service/queryService';
import { isSelectQuery } from '../utils/queryValidator';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';

interface UseExecuteQueryProps {
  favoriteQuery: NewFavoriteQuery;
  customerIds: string[];
  setResults: (results: CustomerMassQueryResult) => void;
  setError: (error: string) => void;
  setLoading: (loading: boolean) => void;
}

export const useExecuteQuery = ({
  favoriteQuery,
  customerIds,
  setResults,
  setError,
  setLoading,
}: UseExecuteQueryProps) => {
  const { t } = useTranslation('sqlengine');
  const handleExecute = async () => {
    if (!isSelectQuery(favoriteQuery?.QueryText ?? '')) {
      setError(t('sqlengine.error.invalidQuery'));
      return;
    }
    if (customerIds.length < 1) {
      setError(t('sqlengine.error.filterValidation'));
      return;
    }

    setLoading(true);
    const executeCustomerQuery: ExecuteMassCustomerQuery = {
      CustomerIds: customerIds,
      SqlQuery: favoriteQuery?.QueryText ?? '',
    };
    try {
      showToast({
        title: t('sqlengine.info.executingQuery'),
        type: 'info',
      });
      const data =
        await queryService.executeCustomerQuery(executeCustomerQuery);
      setResults(data);
      showToast({
        title: t('sqlengine.success.queryExecuted'),
        type: 'success',
      });
      setError('');
    } catch (e) {
      console.error(e);
      setError(t('sqlengine.error.executionFailed'));
    } finally {
      setLoading(false);
    }
  };

  return { handleExecute };
};
